const zh = {
  translation: {
    // Navigation
    'home': '首页',
    'about_us': '关于我们',
    'services': '服务',
    'contact': '联系我们',
    'locations': '服务地点',

    // Home page content
    'hero_title': '优质航空机组人员运输服务',
    'hero_title_first_line': '优质航空机组人员',
    'hero_title_second_line': '运输服务',
    'hero_subtitle': '我们是旧金山、洛杉矶、硅谷、佛罗里达、纽约市、德克萨斯州和澳大利亚悉尼地区首屈一指的运输服务提供商。',
    'hero_cta_first_line': '联系我们的',
    'hero_cta_second_line': '航空机组运输',
    'hero_cta_third_line': '礼宾专员',
    'hero_cta': '联系我们的航空机组运输礼宾专员',

    // About section
    'about_title': '关于我们',
    'about_description': '是北美领先的航空机组人员和酒店班车服务提供商。近30年来，我们一直走在为全球航空公司机组人员提供可靠、安全和高效运输解决方案的前列。',
    'about_years': '卓越服务多年',
    'about_global_locations': '全球服务网点',
    'about_service': '服务与支持',
    'get_in_touch': '联系我们的航空机组运输礼宾专员',
    'about_second_paragraph': '我们对卓越、准时和客户满意度的承诺使我们成为众多国际航空公司的首选。我们了解航空机组人员的独特需求，并量身定制我们的服务，确保从接送到送达的全程舒适无忧。',

    // In Good Company section
    'in_good_company_title': '与优秀企业为伍',
    'in_good_company_description': '获得世界领先航空公司的信任，提供可靠优质的运输服务。',

    // Testimonials section
    'testimonials_title': '客户评价',
    'testimonials_description': '了解为什么领先的航空公司和客户选择我们的运输服务。',

    // Testimonial quotes
    'testimonial_1_quote': "我在与航空机组运输经理合作制定机组人员夏季时间表时度过了愉快的时光。",
    'testimonial_1_author': "北欧航空",
    'testimonial_1_company': "站点经理",

    'testimonial_2_quote': "我们终于找到了一个宝藏服务。",
    'testimonial_2_author': "Aish婚礼服务",
    'testimonial_2_company': "首席执行官兼经理",

    'testimonial_3_quote': "当我被推荐使用航空机组运输服务来接送我们的飞行和机舱机组人员往返酒店时，我终于可以少操一份心了。",
    'testimonial_3_author': "以色列航空",
    'testimonial_3_company': "站点经理",

    // Services section
    'services_title': '我们的服务',
    'services_description': '探索我们的优质运输选项，每一项都旨在舒适可靠地满足您的特定需求。',
    'select_a_service': '选择服务',
    'get_a_quote': '获取报价',

    // Service items
    'service_airport_transfer_title': '机场接送',
    'service_airport_transfer_bullet1': '准时接送，确保运营顺畅。',
    'service_airport_transfer_bullet2': '车辆清洁，设备齐全，每次出行都舒适。',

    'service_distressed_passengers_title': '延误旅客运输',
    'service_distressed_passengers_bullet1': '全天候24/7快速响应航班延误和取消。',
    'service_distressed_passengers_bullet2': '高效转移旅客至酒店或替代机场。',

    'service_any_occasion_title': '各类场合用车服务',
    'service_any_occasion_bullet1': '为企业活动和会议提供优质运输服务。',
    'service_any_occasion_bullet2': '专业服务确保高管精神饱满地抵达。',

    'service_hotel_transfer_title': '酒店接送',
    'service_hotel_transfer_bullet1': '酒店与机场之间的无缝协调。',
    'service_hotel_transfer_bullet2': '完美配合早出晚归的时间安排。',

    'service_flight_cabin_crew_title': '飞行与机舱机组班车',
    'service_flight_cabin_crew_bullet1': '专业服务，深谙航空运营要求。',
    'service_flight_cabin_crew_bullet2': '严格遵守机组时间安排协议。',

    'service_company_shuttle_title': '公司班车服务',
    'service_company_shuttle_bullet1': '为员工和高管提供定制运输解决方案。',
    'service_company_shuttle_bullet2': '固定路线配备实时跟踪和成本效益。',

    'service_charter_services_title': '包车服务',
    'service_charter_services_bullet1': '为各种规模团体提供量身定制的运输解决方案。',
    'service_charter_services_bullet2': '专业物流规划配备定制车队选择。',

    // Fleet section
    'fleet_title': '我们的车队',
    'fleet_description': '探索我们多样化的豪华车队，每一款车型都经过精心挑选，为您的所有交通需求提供卓越的舒适度、风格和可靠性。',
    'select_a_vehicle': '选择车型',

    // Fleet items
    'fleet_sedan_title': '轿车',
    'fleet_sedan_description': '豪华轿车配备专业司机，提供高管级出行体验。最多可容纳3人。',

    'fleet_suv_title': 'SUV',
    'fleet_suv_description': '高级SUV为小型团体提供宽敞舒适的空间。最多可容纳6人。',

    'fleet_sprinter_title': '斯宾特商务车',
    'fleet_sprinter_description': '梅赛德斯-奔驰斯宾特商务车配备豪华设施，适合中型团体。最多可容纳14人。',

    'fleet_minibus_title': '小型巴士',
    'fleet_minibus_description': '舒适的小型巴士适合较大团体，提供充足的行李空间。最多可容纳27人。',

    'fleet_mini_coach_title': '迷你教练车',
    'fleet_mini_coach_description': '迷你教练车为中大型团体提供高级运输服务。最多可容纳35人。',

    'fleet_coach_title': '大巴',
    'fleet_coach_description': '全尺寸豪华大巴，满足大型团体运输需求。最多可容纳55个座位。',

    // Fleet vehicle details (for carousel)
    'fleet_van_title': '商务车',
    'fleet_van_capacity': '乘客容量 1-3',
    'fleet_van_description': '我们的行政商务车为单个机组成员或小团队提供舒适高效的运输解决方案。\n\n配备宽敞内饰、专业司机和可靠的调度，这些车辆非常适合早班出发、晚班到达以及各种中间时段。',

    'fleet_sprinter_carousel_title': '斯宾特商务车',
    'fleet_sprinter_carousel_capacity': '乘客容量 1-14',
    'fleet_sprinter_carousel_description': '我们的梅赛德斯斯宾特商务车为中型团队提供高级舒适体验，配备充足的行李空间。\n\n配备豪华座椅、气候控制和专业司机，这些车辆是机组转运和团体运输需求的理想选择。',

    'fleet_minivan_title': '小型客车',
    'fleet_minivan_capacity': '乘客容量 1-7',
    'fleet_minivan_description': '我们舒适的小型客车非常适合需要可靠高效运输的小到中等机组团队。\n\n配备灵活的座椅安排和宽敞的货物空间，这些车辆为航空机组需求提供了舒适性和实用性的完美平衡。',

    'fleet_minibus_carousel_title': '小型巴士',
    'fleet_minibus_carousel_capacity': '乘客容量 1-25',
    'fleet_minibus_carousel_description': '我们宽敞的小型巴士专为较大的机组团队设计，提供舒适的座椅和充足的行李存储空间。\n\n配备空调、可调节座椅和平稳的乘坐质量，这些车辆确保您的机组人员以最佳状态到达并准备执行任务。',

    'fleet_minicoach_title': '迷你教练车',
    'fleet_minicoach_capacity': '乘客容量 1-35',
    'fleet_minicoach_description': '我们的高级迷你教练车为大型机组团队提供豪华运输，具有最高的舒适度和风格。\n\n配备豪华座椅、娱乐系统和气候控制，这些教练车为您最重要的机组转运提供一流的旅行体验。',

    // Passenger capacity
    'passenger_capacity': '载客能力',
    'seats': '座位',

    // How We Work section
    'how_we_work_title': '我们的工作方式',
    'how_we_work_description': '我们的卓越承诺建立在三个驱动我们服务质量的核心原则上。',
    'how_we_work_card1_title': '以人为本',
    'how_we_work_card1_description': '对我们来说没有太小、太大或太复杂的工作；无论是运送一两位客户还是多达35名机组成员，您都可以依靠我们。',
    'how_we_work_card2_title': '专业司机',
    'how_we_work_card2_description': '我们的司机都持有专业执照，熟悉路线，尽可能安全地驾驶车辆，始终以高标准和礼貌对待我们的客户。',
    'how_we_work_card3_title': '实时更新',
    'how_we_work_card3_description': '航空机组运输公司建立了高效的中央调度中心，管理司机和巴士的日常调度。我们已实施实时GPS系统，确保所有乘客的安全。',

    // Contact section
    'contact_title': '联系我们',
    'contact_subtitle': '准备好开始了吗？立即联系我们，让我们为您处理运输需求。',
    'contact_name': '姓名',
    'contact_name_placeholder': '您的全名',
    'contact_name_required': '姓名为必填项',
    'contact_email': '电子邮箱',
    'contact_email_placeholder': '您的邮箱地址',
    'contact_email_required': '电子邮箱为必填项',
    'contact_email_invalid': '请输入有效的电子邮箱地址',
    'contact_phone': '电话',
    'contact_phone_placeholder': '您的电话号码',
    'contact_subject': '主题',
    'contact_subject_placeholder': '主题',
    'contact_subject_required': '主题为必填项',
    'contact_message': '留言',
    'contact_message_placeholder': '您的留言',
    'contact_message_required': '留言为必填项',
    'contact_submit': '提交',
    'contact_sending': '发送中...',
    'contact_success': '您的留言已成功发送！',
    'contact_thank_you': '谢谢您！',
    'contact_success_message': '您的留言已成功发送。我们将尽快回复您。',
    'contact_send_another': '发送另一条留言',
    'contact_hours': '工作时间',
    'contact_24_7': '全天候24/7客户服务',

    // Footer
    'footer_copyright': '航空机组运输公司版权所有。',

    // Locations page
    'locations_page_title': '我们的服务地点',
    'locations_page_subtitle': '在全球主要城市提供优质运输服务',

    // San Francisco location
    'location_sf_title': '旧金山',
    'location_sf_description': '是北加州的文化、商业和金融中心。这座城市是最受欢迎的旅游目的地之一。它也是航空机组运输公司总部所在地。',

    // Silicon Valley location
    'location_sv_title': '硅谷',
    'location_sv_description': '是旧金山湾区南部地区。这里是世界上许多最大科技公司的总部。其中包括：财富1000强、Adobe、eBay、苹果、谷歌、Facebook和特斯拉等。',

    // Miami location
    'location_miami_title': '迈阿密',
    'location_miami_description': '迈阿密全年都洋溢着令人兴奋的娱乐场所和景点。航空机组运输公司与迈阿密领先的酒店和住宿建立了良好的合作关系，为您的飞行机组、头等舱和商务舱乘客提供迈阿密最佳体验。',

    // Los Angeles location
    'location_la_title': '洛杉矶',
    'location_la_description': '洛杉矶是美国第二大城市，也是加利福尼亚州人口最多的城市。航空机组运输公司的第二个分支机构便利地位于洛杉矶的LAX机场。',

    // New York City location
    'location_nyc_title': '纽约市',
    'location_nyc_description': '纽约市被评为世界上拍照最多的城市。能让您的公司加入航空机组运输公司不断增长的满意客户名单是我们的荣幸，多年来这些客户因我们卓越的服务而对我们保持忠诚。',

    // Fort Worth location
    'location_fw_title': '沃思堡',
    'location_fw_description': '沃思堡是一个广阔的城市，充满活力和独立精神。我们目前与达拉斯的三家主要酒店有业务往来。我们还为沃思堡机场的四家主要航空公司提供班车服务。',

    // Sydney location
    'location_sydney_title': '澳大利亚悉尼',
    'location_sydney_description': '悉尼是一个您永远不会忘记的目的地，一座拥有标志性景点和迷人海滩的城市。悉尼的航空机组运输公司目前为主要航空公司的飞行和机舱机组人员提供班车服务，并为悉尼最负盛名的住宿场所提供酒店班车计划。',
  }
};

export default zh; 